export default __webpack_public_path__ + "b68f0ba45338eea4a77afc51d6415c05.woff2";